import { useState } from 'react';

import { useAuth } from 'hooks';
import UserProfileDropdown from 'modules/home/components/UserProfileDropdown';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import LocaleSwitcher from './langSelect';
import ActiveLink from '../ActiveLink';
import { MenuIcon, OneXTwo } from '../icons';
import MobileMenu from '../mobile-menu';
import RenderIf from '../RenderIf';

import './Header.css';

const Header = ({ isHome }) => {
  const isAuth = useAuth();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { lang } = useSelector((state) => state.lang);

  const { t } = useTranslation();

  return (
    <header className={`header ${isHome ? 'position-absolute' : ''}`}>
      <div className="container header__container">
        <button
          onClick={() => setIsMenuOpen(true)}
          className="header__mobile-menu"
        >
          <MenuIcon />
        </button>
        <Link to="/" className="header__logo">
          <OneXTwo isHome={isHome} />
        </Link>
        <div className="header__list">
          <ActiveLink
            to="/"
            className="header__list-item"
            activeClassName="header__list-item--active"
          >
            {t('HOME')}
          </ActiveLink>
          <ActiveLink
            to="/bron"
            className="header__list-item"
            activeClassName="header__list-item--active"
          >
            {t('BRON')}
          </ActiveLink>
          <ActiveLink
            to="/circulations"
            className="header__list-item"
            activeClassName="header__list-item--active"
          >
            {t('CIRCULATIONS')}
          </ActiveLink>
          <ActiveLink
            to="/results"
            className="header__list-item"
            activeClassName="header__list-item--active"
          >
            {t('RESULTS')}
          </ActiveLink>

          <RenderIf condition={isAuth}>
            <ActiveLink
              to="/my-tickets"
              className="header__list-item"
              activeClassName="header__list-item--active"
            >
              {t('MY_TICKETS')}
            </ActiveLink>
            <ActiveLink
              to="/my-bron-tickets"
              className="header__list-item"
              activeClassName="header__list-item--active"
            >
              {t('MY_BRON_COUPONS')}
            </ActiveLink>
          </RenderIf>
        </div>
        <div className="header__buttons align-items-center">
          <LocaleSwitcher lang={lang} isHome={isHome} />
          {isAuth ? (
            <div className="ms-auto">
              <UserProfileDropdown />
            </div>
          ) : (
            <div className="d-none d-md-flex align-items-center gap-4">
              <Link
                to="/auth/login"
                className="header__button header__button--outline"
              >
                {t('LOGIN')}
              </Link>
              <Link
                to="/auth/register"
                className="header__button header__button--primary"
              >
                {t('REGISTER')}
              </Link>
            </div>
          )}
        </div>
      </div>
      <MobileMenu open={isMenuOpen} onHide={setIsMenuOpen} />
    </header>
  );
};

export default Header;
